import { configureStore } from "@reduxjs/toolkit";

import {
  type CartState,
  cartReducer,
} from "packages/online_ordering/reducers/cart";
import {
  type CheckoutState,
  checkoutReducers,
} from "packages/online_ordering/reducers/checkout";
import consumer, {
  type ConsumerState,
} from "packages/online_ordering/reducers/consumer/consumer";
import deliveryAddress from "packages/online_ordering/reducers/delivery_address";
import orderingOptions from "packages/online_ordering/reducers/ordering_options";
import publishStatus from "packages/online_ordering/reducers/publish_status";
import authentication from "reducers/authentication";
import type { IOrderingOptionsState } from "types/reducers/ordering_options";
import type { StoreInfo } from "types/reducers/store_info";
import type { StateFromReducer } from "types/shared/StateFromReducer";

import { type OrderingInfoState, orderingInfoReducer } from "./orderingInfo";
import { storeInfoReducer } from "./storeInfo";

export interface OnlineOrderingState {
  // TODO implement the types when you need to touch them
  authentication: StateFromReducer<typeof authentication>;
  cart: CartState;
  checkout: CheckoutState;
  consumer: ConsumerState;
  // TODO implement the types when you need to touch them
  deliveryAddress: StateFromReducer<typeof deliveryAddress>;
  orderingInfo: OrderingInfoState;
  orderingOptions: IOrderingOptionsState;
  // TODO implement the types when you need to touch them
  publishStatus: StateFromReducer<typeof publishStatus>;
  /**
   * @deprecated use useOloStoreInfo
   */
  storeInfo: StoreInfo;
}

export const onlineOrderingReducer = {
  authentication,
  cart: cartReducer,
  checkout: checkoutReducers,
  consumer,
  deliveryAddress,
  orderingInfo: orderingInfoReducer,
  orderingOptions,
  publishStatus,
  /**
   * @deprecated Please use `useOloStoreInfo`
   */
  storeInfo: storeInfoReducer,
};

export const configureOloStore = ({
  preloadedState,
}: { preloadedState?: OnlineOrderingState } = {}) => {
  return configureStore({
    reducer: onlineOrderingReducer,
    preloadedState,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        serializableCheck: false,
      });
    },
  });
};

export type OloStore = ReturnType<typeof configureOloStore>;
